import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { isEmptyArray } from '../../../common/Global/commonFunctions';
import { TaskTagButtonsLayout } from '../../../common/Global/globalStyles.style';
import FrameworkDialog from './frameworkTree';

class FrameworkListDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            frameworkClauseArr:[],
            datalist:[],
            selectedIndex:-1,
            rootNode:{},
            rootFrameworkId:"",
            frameworkType:""
        }
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showFrameworkDialog){
            this.setState({
                frameworkClauseArr:this.props.frameworkClauseArr || [],
                datalist:this.props.datalist,
                selectedIndex:this.props.selectedIndex,
                rootNode:{},
                rootFrameworkId:"",
                frameworkType:this.props.frameworkType
            })
        }
    }

    handleFrameworkClauseDialogShow = (item) => {
        this.setState({
            showFrameworkTreeDialog:true,
            rootFrameworkId:item.frameworkId,
            rootNode:item,
            selectedIndex:this.props.selectedIndex,
        })
    }

    handleFrameworkTreeDialogClose = (newFrameworkClauses, reloadFlag) => {
        if(reloadFlag === true){
            // 1. Recalculate continuous order (1, 2, 3...) for ALL selected clauses
            // This is done on the incoming array (or a copy of it), which already represents 
            // the consolidated, unique list for the field, sorted by selection order.
            let updatedAllClauses = newFrameworkClauses.map((clause, index) => ({
                ...clause,
                frameworkClauseOrder: index + 1 // Assign final continuous order
            }));
            // 2. Update the datalist field with the CLEAN payload
            let tempDatalist = [...this.state.datalist];
            let itemIndex = this.state.selectedIndex;
            if (tempDatalist[itemIndex]) {
                // Store the cleaned list in the specific field's value
                tempDatalist[itemIndex].fieldValue = updatedAllClauses;
            }
            // 3. Update the component state for persistence and display
            this.setState({
                datalist:tempDatalist,
                frameworkClauseArr:updatedAllClauses || [],
                // Reset modal state variables
                // rootFrameworkId:"",
                // rootNode:{},
                // selectedIndex:-1, 
                showFrameworkTreeDialog:false,
            },() => {
                this.props.handleFrameworkDialogClose(this.state.frameworkClauseArr,this.state.datalist, true);
            });
        } else {
            // Close without saving
            this.setState({
                showFrameworkTreeDialog:false,
                // rootFrameworkId:"",
                // rootNode:{},
                // selectedIndex:-1,
            },() => {
                this.props.handleFrameworkDialogClose();
            })
        }
    }

    render() {
        return(
            <div>
                <Modal className="show-framework-tree-dialog custom-dialog"
                show={this.props.showFrameworkDialog} onHide={this.props.handleFrameworkDialogClose} backdrop="static">
                    <Modal.Header>
                        <h5>Framework</h5>
                        <button 
                            onClick={this.props.handleFrameworkDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            <div className="row custom-row">
                            {
                                !isEmptyArray(this.props.frameworkList) && 
                                this.props.frameworkList.map((listItem) => {
                                    return(
                                        <>
                                            <div className="col-md-4 custom-col">
                                                <TaskTagButtonsLayout
                                                themeSettings={this.props.themeSettings}
                                                >
                                                    <div class="template-field-left-layout m-b-10">
                                                        <p className="m-b-5" style={{marginBottom:10}}
                                                            onClick={this.handleFrameworkClauseDialogShow.bind(this,listItem)}
                                                        >
                                                            {listItem.frameworkName}
                                                        </p>
                                                    </div>
                                                </TaskTagButtonsLayout>
                                            </div>
                                        </>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                    <FrameworkDialog
                        showFrameworkTreeDialog={this.state.showFrameworkTreeDialog}
                        handleFrameworkTreeDialogClose={this.handleFrameworkTreeDialogClose}
                        frameworkClauseArr={this.state.frameworkClauseArr}
                        rootFrameworkId={this.state.rootFrameworkId}
                        rootNode={this.state.rootNode}
                        frameworkType={this.props.frameworkType}
                        themeSettings={this.props.themeSettings}
                    />
                </Modal>
            </div>
        )
    }
}
export default FrameworkListDialog;